/**
 * @module app.cd
 */

import * as CD from 'app/cd/models/essette-api';
import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { apiCall } from 'app/shared/lib/api/api';
import { AuthService } from 'app/cd/services/auth-service';
import { openProviderLocationSummary } from 'app/cd/components/summary/provider/provider-summary';

@autoinject()
export class ProviderInformation extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    protected authId: string | null = null;

    protected auth: CD.Auth | null = null;

    protected showProviderSummaryLink: boolean = false;
    protected openProviderLocationSummary = openProviderLocationSummary;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: AuthService,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
        this.checkPermissions();
    }

    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        if(this.authId) {
            this.loadAuth();
        }
    }

    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        this.showProviderSummaryLink = this.accountContext.hasRouteAccess('cd.provider.summary');
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuth(): Promise<void> {
        if(!this.authId) return;

        const includes: string[] = [
            'providers',
            'providers.detail.type',
            'providers.location'
        ];

        try {
            this.state.beginLoad();

            const response = await this.service.loadAuth(this.authId, includes);
            this.auth = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
